import { axiosGet } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { ReadAdminWalletsParams } from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 관리자 지갑 목록 조회
export const readAdminWallets = async (params?: ReadAdminWalletsParams) => {
  const queryParams = new URLSearchParams();

  if (params?.page !== undefined) {
    queryParams.append('page', String(params.page));
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', String(params.limit));
  }

  const queryString = queryParams.toString();
  const path = `/assetfi/admin/staking/wallets${queryString ? `?${queryString}` : ''}`;

  const payload: EndpointPayload = {
    path,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'readAdminWallets', axiosGet);
};

// 관리자 지갑 상세 조회
export const readAdminWalletDetail = async (walletId: string) => {
  const payload: EndpointPayload = {
    path: `/assetfi/admin/staking/wallets/${walletId}`,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'readAdminWalletDetail', axiosGet);
};
